import { Directive, ElementRef, Input, Inject, PLATFORM_ID, AfterViewInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({ selector: '[fittext]' })
export class FittextDirective implements AfterViewInit {
  @Input() maxFontSize: number;

  constructor(private el: ElementRef, @Inject(PLATFORM_ID) private platformId: any) {}

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return; // noop on server
    }

    try {
      const element = this.el.nativeElement as HTMLElement;
      const max = this.maxFontSize || 42;
      // very small, non-invasive fit: scale down if text width exceeds container
      const parentWidth = element.parentElement ? element.parentElement.clientWidth : element.clientWidth;
      const computed = window.getComputedStyle(element);
      const fontSize = parseInt(computed.fontSize || '16', 10);
      if (element.scrollWidth > parentWidth) {
        let newSize = Math.max(12, Math.floor((parentWidth / element.scrollWidth) * fontSize));
        if (newSize > max) { newSize = max; }
        element.style.fontSize = newSize + 'px';
      }
    } catch (e) {
      // silently ignore
    }
  }
}
